import { ChangeDetectionStrategy, Component, Inject, PLATFORM_ID } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 
import {MatIconModule} from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TrainingAttandanceEntryComponent } from '../training-attandance-entry/training-attandance-entry.component';
@Component({
  selector: 'app-training-plan-execution',
  imports: [MatSelectModule, MatInputModule, MatFormFieldModule, MatCheckboxModule, MatDatepickerModule, MatNativeDateModule,
    MatIconModule, MatRadioModule, CommonModule, FormsModule, ReactiveFormsModule, MatDialogModule,
    MatButtonModule,],
  templateUrl: './training-plan-execution.component.html',
  styleUrl: './training-plan-execution.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingPlanExecutionComponent {
  message: any = null;
  messagetwo: any = null;
  messagereturn: any = null;
  isBrowser = false;

  // Separate file name holders
  kitFileName: string = '';
  materialFileName: string = '';
  refreshmentFileName: string = '';
  envionmentFileName: string = '';

  // To store actual file objects
  selectedFiles: { [key: string]: File } = {};
    executedata = [
      { id: 1, dates: '2025-11-10' },
      { id: 1, dates: '2025-11-11'},
      { id: 1, dates: '2025-11-12' },
    ];

    constructor(
     private router: Router,
    private dialog: MatDialog,
     @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    
  }
   
    // popupopen
    navigateToattandanceentry(id: number, date:string) {
        //console.log('Navigating to /dashboard/training-plan-details', id);
        //this.router.navigate(['/dashboard/training-plan-details'], { queryParams: { id } });
        //alert(id+date);
        this.dialog.open(TrainingAttandanceEntryComponent, {
          width: '90vw',
          maxWidth: '1200px',
          height: '90vh',
          maxHeight: '95vh',
          panelClass: 'responsive-dialog',
          data: { id: id, fdate: date }, // 👈 match the component property
        });
        
    }
}
